import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  getSessionID,
  getSessionUser,
} from "./../../common/services/sessionServices";

import { Route } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import UserContext from "./../../common/context/userContext";
import SideMenuContext from "./../../common/context/sideMenuContext";
import LoadTamar from "./../../Mapi/components/fields/LoadTamar";
import SideBarMapi from "./../components/fields/sidebar";
import MyAccount from "./../../common/components/myaccount";
import Login from "./../../common/components/login";
import Contact from "./../../common/components/contact";
import AboutUs from "./../../common/components/about";

import ForgotPassword from "./../../common/components/forgotPassword";
import ResetPassword from "./../../common/components/resetPassword";
import ServicesHelp from "./../../common/components/servicesHelp";
import OneTimeLoginForm from "./../../common/components/forms/onetimeLoginform";
import StandardLoginForm from "./../../common/components/forms/standardLoginForm";
import sideMobileMenu from "./../../common/components/sideMobileMenu";
import UploadDict from "./../../common/components/forms/uploadDict";
import CreateProject from "../../common/components/createProject";
import ProjectsList from "../../common/components/projectsList";
import ProjectDetails from "../../common/components/projectDetails";
import { getDynamicFieldsFromMenu } from "../../common/services/uiService";
import { useSelector } from "react-redux";
import { capitalizeKeys } from "../../common/services/helper";
import { useAuth } from "../contexts/AuthContext";
import { ConfigContext } from "./../../common/context/ConfigContext";
import { devLogin } from "../../common/services/authService";

//import "./../styles/LoadTamar.css";
const assignResultValuesToMenuItems = (obj, array) => {
  return array.map((item) => ({
    ...item,
    value: obj?.[item?.id] !== undefined ? obj?.[item?.id] : null,
  }));
};

const Home = ({
  generalEndPoint,
  socketConnectionEndPoint,
  location,
  match,
  history,
}) => {
  const { isAuthenticated, isLoading, login } = useAuth();
  const config = useContext(ConfigContext);
  const [showWellcome, setWellcome] = useState(true);
  const [activeForm, setActiveForm] = useState();
  const [isFileProcessInQueue, setFileProcessInQueue] = useState(false);
  const [routeData, setRouteData] = useState();
  const [devLoginSucceeded, setDevLoginSucceeded] = useState(false);
  const selectedProject = useSelector(
    (state) => state?.project?.NewProject?.project
  );
  const context = useContext(UserContext);
  const sideMenuContext = useContext(SideMenuContext);
  let menues = sideMenuContext.menues;
  const functionsSet = new Set();

  const shouldAttemptDevLogin = useCallback(() => {
    const isDevelopment = config?.env === "Development";
    return (
      config &&
      config.project === "Mapi" &&
      isDevelopment &&
      config.generalEndPoint
    );
  }, [config]);

  const handleDevLoginAttempt = useCallback(async () => {
    try {
      const devLoginResponse = await devLogin(config.generalEndPoint);

      if (devLoginResponse?.data?.isValid && devLoginResponse?.data?.token) {
        login({
          token: devLoginResponse.data.token,
          user: devLoginResponse.data.user,
        });
        setDevLoginSucceeded(true);
        return;
      }
    } catch (error) {
      // If dev-login endpoint doesn't exist (404), treat as PROD mode
      if (error?.response?.status === 404) {
        console.log("Dev-login endpoint not found (404) - treating as PROD mode");
        history.push("/login");
        return;
      }
      console.error("DEV LOGIN ERROR:", error);
    }
    
  }, [config, login, history]);


  // Handle authentication check, dev-login attempt (if dev), and redirect
  useEffect(() => {
    if (isLoading || isAuthenticated || location.pathname.includes("/login") || devLoginSucceeded) return;

    // If dev environment and haven't attempted yet, try dev-login
    if (shouldAttemptDevLogin()) {
      handleDevLoginAttempt();
      return;
    }
     history.push("/login");
  }, [isLoading, isAuthenticated, location.pathname, shouldAttemptDevLogin, handleDevLoginAttempt, devLoginSucceeded, history]);

  // const [sessionID, setSessionID] = useState(null);

  // const storedSessionID = useMemo(() => {
  //   try {
  //     const sessionID = localStorage.getItem('sessionID');
  //     return sessionID ? JSON.parse(sessionID) : null; // Parse for safety
  //   } catch (error) {
  //     console.error('Error retrieving sessionID from local storage:', error);
  //     return null;
  //   }
  // }, []); // Empty dependency array to run only once

  // useEffect(() => {
  //   const fetchSessionID = async () => {
  //     try {
  //       // Replace with your actual logic to fetch session ID
  //       // (e.g., API call, server-side generation, etc.)
  //       const newSessionID = getSessionID(); // Placeholder

  //       if (newSessionID) {
  //         localStorage.setItem('sessionID', JSON.stringify(newSessionID));
  //         setSessionID(newSessionID);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching sessionID:', error);
  //     }
  //   };

  //   if (!storedSessionID) {
  //     fetchSessionID();
  //   }
  // }, [storedSessionID]); // Dependency on storedSessionID

  const showFirstMessage = useCallback(() => {
    setWellcome(true);
  }, [showWellcome]);

  const hideFirstMessage = useCallback(
    (item) => {
      setActiveForm(item);
      setWellcome(false);
    },
    [showWellcome]
  );

  const ShowMyAccount = useCallback(() => {
    setWellcome(false);
    history.push("/home/myaccount");
  }, [showWellcome]);

  functionsSet.add(showFirstMessage);
  functionsSet.add(hideFirstMessage);
  functionsSet.add(ShowMyAccount);

  //functionsSet.add(collapseMobileMenu);

  const componentsMap = {
    LoadTamar,
    MyAccount,
    AboutUs,
    Contact,
    SideBarMapi,
    sideMobileMenu,
    Login,
    OneTimeLoginForm,
    StandardLoginForm,
    UploadDict,
  };

  const fileInProcessQueue = (response) => {
    setFileProcessInQueue(response);
  };

  const stopRunningProcess = () => {
    setActiveForm();
  };

  useEffect(() => {
    //console.log("Mapi home component");
    function getMenues() {
      if (!menues || menues.length === 0) {
        sideMenuContext.onHandleSideMenu();
        menues = sideMenuContext.menues;
      }
    }

    menues = getMenues();
    if (location.pathname !== "/home/intake" && location.pathname !== "/") {
      hideFirstMessage();
    } else {
      if (context.user) {
        showFirstMessage();
        //ShowMyAccount();
      } else {
        showFirstMessage();
      }
    }

    var body = document.body,
      html = document.documentElement;

    var height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    if (isBrowser) {
      var workAreaDiv = document.getElementById("workArea");
      if (workAreaDiv !== undefined) {
        var mainNavBarDiv = document.getElementById("mainNavBar");

        if (mainNavBarDiv !== undefined) {
          if (
            document.getElementsByClassName("PersonalZoneWrapper").length > 0
          ) {
            var pzw = document.getElementsByClassName("PersonalZoneWrapper")[0];
            let desktopAddion = 0;
            if (isBrowser) {
              desktopAddion = 320;
            }

            // workAreaDiv.style.height =
            //   (pzw.offsetHeight + desktopAddion).toString() + "px";
          } else {
            if (
              document.getElementsByClassName("AppTrackFormDesc").length === 0
            ) {
              // workAreaDiv.style.height =
              //   (
              //     (window.innerHeight) -
              //     mainNavBarDiv.offsetHeight -
              //     2
              //   ).toString() + "px";
            }
          }
        } else {
          // alert("mainNavBarDiv not found");
        }
      }
    }

    // if (context.user) {
    //   ShowMyAccount();
    // }

    //setWellcomeVisibility(false);
    // setWellcome(true);false
  });

  useEffect(() => {
    if (location.state?.preData) {
      setRouteData(location.state?.preData);
    }

    let activeTabMenu = sideMenuContext.activeTabData;
    async function fetchData() {
      try {
        if (activeTabMenu?.length === 0) {
          activeTabMenu = await getDynamicFieldsFromMenu(generalEndPoint, 2);
        }
        const updatedResult = assignResultValuesToMenuItems(
          capitalizeKeys(selectedProject),
          activeTabMenu
        );
        sideMenuContext.setActiveTabData(updatedResult);
        sideMenuContext.setSelectedMenu({
          itemId: 2,
          formId: 1,
          parentItemId: 1,
          id: "AboutUs",
          title: 'ביצוע בדיקות וטעינת תמ"ר',
          objectName: "Home",
          to: "/home",
          img: "LandRegister.svg",
          activeImg: "",
          nonActiveImg: "",
          index_: 1,
          formName: "Menu",
          typeId: null,
          typeName: null,
          allowNull: true,
          disabled: false,
          beforeSpace: "",
          beforeSpaceClass: "",
          regClassName: "ChildSideMenuLink nav-item ",
          activeClassName: "ChildSideMenuLink ChildMenuActive nav-item active",
          regTitleClassName: "ChildMenuTitle",
          activeTitleClassName: "ChildMenuTitle active",
        });
        hideFirstMessage(updatedResult);
        history.replace({ pathname: location.pathname, state: {} });
      } catch (error) {
        console.error("Error fetching dynamic fields:", error);
      }
    }

    if (location.state?.data && typeof location?.state !== "string") {
      fetchData();
    }
  }, [location, selectedProject]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      sideMenuContext.setActiveTabData([]);
      sideMenuContext.setSelectedMenu(null);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    // <SideMenuContext.Consumer>
    //   {(sideMenuContext) => (
    <div className="contentSidebarWrapper">
      <div id="LeftBarMenuDiv" className="LeftBarMenuDiv">
        <SideBarMapi
          handleClick={hideFirstMessage}
          currentLocation={location.pathname}
          isDisabled={isFileProcessInQueue}
          generalEndPoint={generalEndPoint}
        />
      </div>

      <div id="workArea">
        {showWellcome && activeForm ? (
          <div id="wellcomeDiv">
            {/* <WellcomeComponent showWellcome={showWellcome} /> */}
            <LoadTamar
              isProcesssInQueue={fileInProcessQueue}
              isDisabled={isFileProcessInQueue}
              stopAllRunningProcess={stopRunningProcess}
              generalEndPoint={generalEndPoint}
              socketConnectionEndPoint={socketConnectionEndPoint}
              extraParams={routeData}
            />
          </div>
        ) : null}
        {menues !== undefined && !menues
          ? menues.map((mItem, ind) => (
              <Route
                path={mItem.to}
                key={ind}
                component={componentsMap[mItem.objectName]}
              />
            ))
          : null}
        <Route path="/home/uploadDict" component={UploadDict} />
        <Route
          path="/home/create-project"
          render={(props) => (
            <CreateProject
              {...props}
              generalEndPoint={generalEndPoint}
              socketConnectionEndPoint={socketConnectionEndPoint}
            />
          )}
        />
        <Route
          path="/home/projects"
          render={(props) => (
            <ProjectsList
              {...props}
              generalEndPoint={generalEndPoint}
              socketConnectionEndPoint={socketConnectionEndPoint}
            />
          )}
        />
        <Route
          path="/home/project-details/:projectId"
          render={(props) => (
            <ProjectDetails
              {...props}
              generalEndPoint={generalEndPoint}
              socketConnectionEndPoint={socketConnectionEndPoint}
            />
          )}
        />
        <Route path="/home/login/1" key="20" component={Login} />
        <Route path="/home/login/2" key="25" component={Login} />
        <Route path="/home/forgotpwd" key="40" component={ForgotPassword} />
        <Route
          path="/home/resetPwd/:token?"
          key="50"
          component={ResetPassword}
        />
        <Route
          path="/home/serviceshelp/:type?"
          key="60"
          component={ServicesHelp}
        />
      </div>
    </div>
  );
};

// Home.contextType = UserContext;
export default Home;
